<script setup lang="ts">
    import AppMenuDarkSwitcher from '@/components/menu/AppMenuDarkSwitcher.vue';
    import AppMenuNav from '@/components/menu/AppMenuNav.vue';
    import AppMenuHelp from '@/components/menu/AppMenuHelp.vue';
    import AppMenuAccountChangeLocaleAndTimeZone from '@/components/menu/AppMenuAccountChangeLocaleAndTimeZone.vue';
    import { useMenuStore } from '@/stores/menu';
    import { computed, watch } from 'vue';
    import { useDisplay, useTheme } from 'vuetify';

    const menuStore = useMenuStore();
    const display = useDisplay();
    const theme = useTheme();
    const { t } = useI18n();

    const navMenuGuestItems = computed(() => menuStore.getNavMenuItemsGuest);

    const isDesktopMenu = computed<boolean>(() => display.width.value >= 975);

    watch(isDesktopMenu, (value: boolean) => {
        if (value && menuStore.mobileMenuDrawer) {
            menuStore.mobileMenuDrawer = false;
        }
    });
</script>
<template>
    <v-card class="overflow-hidden">
        <v-app-bar id="menu" app dense flat tile elevation="0" color="#fff" class="menu-border menu" height="47">
            <AppMenuNav v-if="isDesktopMenu" :items="navMenuGuestItems"></AppMenuNav>

            <v-app-bar-nav-icon v-else class="ml-2 ml-md-0" @click="menuStore.mobileMenuDrawer = true">
                <v-icon :color="theme.name.value === 'dark' ? '#b5bac1' : 'tbGreen'" style="background: transparent !important" :icon="mdiMenu" />
            </v-app-bar-nav-icon>

            <div style="width: 55%; display: flex; justify-content: right">
                <v-icon size="18" :icon="mdiAlertCircleOutline" class="mt-auto mb-auto" style="color: #f00; margin-top: 1px" />
                <span class="oddsText">{{ t('guest.oddsDelayed') }}</span>
            </div>

            <v-spacer></v-spacer>

            <!--            <AppMenuBreadcrumbs></AppMenuBreadcrumbs>-->

            <AppMenuDarkSwitcher></AppMenuDarkSwitcher>

            <v-menu offset-y v-model="menuStore.userMenu" :close-on-content-click="false" :nudge-width="200" offset-x>
                <template #activator="{ props }">
                    <v-btn
                        tag="a"
                        class="link-menu"
                        :height="display.xs.value ? 30 : 46"
                        min-width="30"
                        :width="display.xs.value ? 30 : 50"
                        variant="text"
                        v-bind="props"
                        :data-tooltip="t('menu.account')"
                    >
                        <v-icon size="24" :color="theme.name.value === 'dark' ? '' : '#867878'" :icon="mdiAccountBoxOutline" />
                    </v-btn>
                </template>

                <v-card width="350px">
                    <AppMenuAccountChangeLocaleAndTimeZone></AppMenuAccountChangeLocaleAndTimeZone>
                </v-card>
            </v-menu>

            <AppMenuHelp :items="menuStore.navMenuSupportItems"></AppMenuHelp>
        </v-app-bar>
        <!--        <AppMenuMobile :items="navMenuGuestItems"></AppMenuMobile>-->
    </v-card>
</template>
<style scoped>
    .v-theme--light .menu-border {
        border-bottom: 1px solid #e0e0e0 !important;
    }

    .v-theme--dark .menu-border {
        border-bottom: 1px solid #404148 !important;
    }

    .v-theme--dark .menu {
        background-color: #1e1f22 !important;
    }
    .v-theme--dark .oddsText {
        color: #f0f0f0;
    }

    .oddsText {
        font-size: 13px;
    }
    @media (max-width: 460px) {
        .oddsText {
            font-size: 10px;
        }
    }
    @media (max-width: 380px) {
        .oddsText {
            font-size: 8px;
        }
    }
</style>
